
import Navbar from "@/components/Navbar";
import PromoBanner from "@/components/PromoBanner";
import HeroSection from "@/components/HeroSection";
import FeaturesSection from "@/components/FeaturesSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import BoothSpecsSection from "@/components/BoothSpecsSection";
import FoundersSection from "@/components/FoundersSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

const Index = () => {
  return (
    <div className="min-h-screen bg-white">
      <ScrollToTop />
      <Navbar />
      <div className="pt-16">
        <PromoBanner />
      </div>
      <HeroSection />
      <FeaturesSection /> {/* Benefits for Property Owners */}
      <HowItWorksSection /> {/* How Quiet Cove Works + Experience section */}
      <BoothSpecsSection /> {/* Booth Specs & Certifications */}
      <FoundersSection /> {/* Experienced Founding Team */}
      <div className="bg-white">
        <div className="pt-10 pb-2 text-center">
          <h2 className="font-montserrat text-4xl md:text-5xl font-extrabold text-quietcove-blue mb-10">Contact Us</h2>
        </div>
        <ContactSection />
      </div>
      <Footer />
    </div>
  );
};

export default Index;
